import { render, staticRenderFns } from "./AuthorizedService.vue?vue&type=template&id=9169701c&"
import script from "./AuthorizedService.vue?vue&type=script&lang=js&"
export * from "./AuthorizedService.vue?vue&type=script&lang=js&"
import style0 from "./AuthorizedService.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports